import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import HomePage from './pages/HomePage';
import DashboardLayout from './components/layout/DashboardLayout';
import DashboardPage from './pages/DashboardPage';
import ProductsPage from './pages/ProductsPage';
import TestsPage from './pages/TestsPage';
import AdminPage from './pages/AdminPage';
import ProductCatalogPage from './pages/ProductCatalogPage';
import ImageGenerationViewPage from './pages/ImageGenerationViewPage';
import VideoGenerationViewPage from './pages/VideoGenerationViewPage';
// import ProductCardPage from './pages/ProductCardPage';

// Импорт юридических страниц
import TermsPage from './pages/legal/TermsPage';
import RefundPolicyPage from './pages/legal/RefundPolicyPage';
import PrivacyPolicyPage from './pages/legal/PrivacyPolicyPage';
import ImprintPage from './pages/legal/ImprintPage';
import CookieConsentConfig from './components/legal/CookieConsentConfig'; // Импорт компонента куки
import PricingPage from './pages/pricing/PricingPage';


import AdminRoute from './components/auth/AdminRoute';

/**
 * Simple guard: if a JWT is stored in localStorage, allow access.
 * Otherwise redirect to the public home page.
 */
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    const token = localStorage.getItem('token');
    return token ? <>{children}</> : <Navigate to="/" replace />;
};

const App = () => (
    <>
        {/* Глобальный конфиг куки (баннер появится поверх всего) */}
        <CookieConsentConfig />

        <Routes>
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />

            {/* Legal Pages (Public) - Требование Paddle */}
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/refund-policy" element={<RefundPolicyPage />} />
            <Route path="/imprint" element={<ImprintPage />} />
            <Route path="/pricing" element={<PricingPage />} />

            {/* Protected dashboard area */}
            <Route
                path="/dashboard/*"
                element={
                    <ProtectedRoute>
                        <DashboardLayout />
                    </ProtectedRoute>
                }
            >
                <Route index element={<DashboardPage />} />
                <Route path="products" element={<ProductsPage />} />
                <Route path="products/:productId/generate-images" element={<ImageGenerationViewPage />} />
                <Route path="products/:productId/generate-images/:generationId" element={<ImageGenerationViewPage />} />
                <Route path="products/:productId/generate-videos" element={<VideoGenerationViewPage />} />
                <Route path="products/:productId/generate-videos/:generationId" element={<VideoGenerationViewPage />} />
                <Route path="catalog/:productId?" element={<ProductCatalogPage />} />

                {/* Маршрут для страницы со списком тестов */}
                <Route path="tests" element={<TestsPage />} />
                {/* Маршрут для отображения конкретного теста по ID */}
                <Route path="tests/:activeTestId" element={<TestsPage />} />

                <Route
                    path="admin"
                    element={
                        <AdminRoute>
                            <AdminPage />
                        </AdminRoute>
                    }
                />
                {/* Fallback inside the dashboard */}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Route>

            {/* Global fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    </>
);

export default App;
